import { ComboBox, IComboBoxOption, Label, Stack } from '@fluentui/react'
import { Plan } from '../../api/models'

type PlanFilterProps = {
  plans: Plan[]
  selectedPlanId?: number
  onChange: (planId: number | undefined) => void
}

const PlanFilter = ({ plans, selectedPlanId, onChange }: PlanFilterProps) => {
  const options: IComboBoxOption[] = [
    { key: 'all', text: 'All Plans' },
    ...plans.map((p) => ({ key: p.id, text: p.name })),
  ]

  return (
    <Stack>
      <Label>Plan</Label>
      <ComboBox
        selectedKey={selectedPlanId ?? 'all'}
        options={options}
        autoComplete="on"
        allowFreeInput
        onChange={(_, option) => {
          if (option) {
            onChange(option.key === 'all' ? undefined : (option.key as number))
          }
        }}
        styles={{ root: { width: 200 } }}
      />
    </Stack>
  )
}

export default PlanFilter
